/* Copyright (c) 2025 Xperi. All Rights Reserved. */

// eslint-disable-next-line no-shadow
export enum PlayNextState {
    NONE,
    PLAY_NEXT_TIMER_ENDED,
    PLAY_NEXT_WHISPER_ENDED,
    PLAY_NEXT_BANNER_ENDED,
}
